<template>
    <section class="favourites-list-section mgt-5 mgb-5">
        <div class="section-loading-screen" v-if="showLoading">
            <div class="section-loading-bubbles">
                <span class="d1"></span>
                <span class="d2"></span>
                <span class="d3"></span>
                <span class="d4"></span>
            </div>
        </div>
        <div class="container-fluid">
            <div class="custom-container container">
                <div class="projects-list-row projects-list-row">
                    <div class="row mb-4 mt-2">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="favourites-login__message favourites-login__message--mobile">
                                Pentru a-ti pastra ofertele la favorite
                                <a class="favourites-login__button" href="/autentificare">
                                Intra in cont / Cont nou
                                </a>
                            </div>
                            <div class="section-heading favourites-login__heading">
                                <div class="favourites-login__title-container">
                                    <i class="fad fa-project-diagram"></i>
                                    <h1 class="m-color">
                                        Proiecte Favorite
                                    </h1>
                                </div>
                                <div class="favourites-login__message">
                                    Pentru a-ti pastra ofertele la favorite
                                    <a class="favourites-login__button" href="/autentificare">
                                    Intra in cont / Cont nou
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div v-for="(project, key) in projects" :key="key"
                                    class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mgb-3">
                                    <div class="element-box favourite-element-box">
                                        <div class="floating-favourite-element" data-toggle="tooltip" data-placement="top" title="Numar modele favorite din proiect">
                                            <i class="fas fa-heart"></i>
                                            <span> {{ getProjectFavoriteModelCount(project.id) }} </span>
                                        </div>
                                        <div class="saved-item-action" @click="deleteFavoriteProject(project.id)">
                                            <span> Elimina </span>
                                            <i class="fas fa-heart-broken"></i>
                                        </div>
                                        <div class="element-dropdown">
                                            <div class="element-floating-menu" @click="setActiveDropdownProject(key)">
                                                <i class="fad fa-ellipsis-v-alt"></i>
                                            </div>
                                            <ul
                                                class="actions-dropdown"
                                                :class="{ 'actions_dropdown_active': activeIndexProject === key }"
                                                ref="dropdown"
                                            >
                                                <li>
                                                    <i class="fad fa-phone-rotary"></i>
                                                    <a href="javascript:void(0)" @click="openPublicContactModalProject(project)" class="general-link"> Call </a>
                                                </li>
                                                <li>
                                                    <i class="fad fa-copy"></i>
                                                    <a href="javascript:void(0)" class="general-link" @click="copyLink(project, 'project')"> Copy link </a>
                                                </li>
                                                <li>
                                                    <i class="fab fa-whatsapp"></i>
                                                    <a :href="`https://api.whatsapp.com/send?text=${project.absoluteUrl}`"
                                                       class="general-link"
                                                       target="_blank"
                                                    >
                                                        Share Whatsapp
                                                    </a>
                                                </li>
                                                <li>
                                                    <i class="fab fa-facebook-square"></i>
                                                    <a  :href="`https://www.facebook.com/sharer/sharer.php?u=${project.absoluteUrl}`"
                                                       class="general-link"
                                                       target="_blank"
                                                    >
                                                        Share Facebook
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="element-header">
                                            <div class="element-logo" :style="{ backgroundImage: 'url(' + project.logo_url + ')' }"></div>
                                            <div class="element-info">
                                                <a :href="`${project.url}`" class="general-link element-name">
                                                    {{ project.name }}
                                                </a>
                                                <div class="element-location">
                                                    <i class="fad fa-map-marker-alt"></i>
                                                    <p>
                                                        {{ getProjectLocation(project) }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="element-body">
                                            <p class="element-description">
                                                {{ project.short_desc }}
                                            </p>
                                            <a
                                                :href="`${project.url}`"
                                                class="element-image"
                                                :style="{ backgroundImage: 'url(' + project.profile_image_url + ')' }"
                                            >
                                                <div
                                                    class="element-status element-new-status"
                                                    v-if="checkNewFlag(project)"
                                                >
                                                    Nou
                                                </div>
                                                <div class="pb">
                                                    <p class="tag tag-photo">
                                                        <i class="fad fa-image"></i>
                                                        <span> {{ project.media_count }} </span>
                                                    </p>
                                                    <p class="tag tag-video">
                                                        <i class="fad fa-play-circle"></i>
                                                        <span> {{ project.videos.length }} </span>
                                                    </p>
                                                </div>
                                            </a>
                                            <div class="element-particularities">
                                                <div class="ep ep1" v-if="project.apartments_models_count > 0">
                                                    <i class="fad fa-building"></i>
                                                    <span
                                                        v-if="!project.hasAccessToProjectItems"
                                                        class="item-action-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Pentru informatii despre numarul de apartamente disponibil sunati la numarul de contact din proiect"
                                                    >
                                                        <i class="fad fa-info-circle"></i> Apartamente
                                                    </span>
                                                    <span
                                                        v-else-if="project.apartments_count === 0"
                                                        class="item-action-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                                    >
                                                        <i class="fad fa-info-circle"></i> Apartamente
                                                    </span>
                                                    <span v-else>
                                                        {{ project.apartments_count }} Apartamente
                                                    </span>
                                                </div>
                                                <div class="ep ep2" v-if="project.houses_models_count > 0">
                                                    <i class="fad fa-home-lg-alt"></i>
                                                    <span
                                                        v-if="!project.hasAccessToProjectItems"
                                                        class="item-action-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Pentru informatii despre numarul de case disponibil sunati la numarul de contact din proiect"
                                                    >
                                                        <i class="fad fa-info-circle"></i> Case
                                                    </span>
                                                    <span
                                                        v-else-if="project.houses_count === 0"
                                                        class="item-action-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                                    >
                                                        <i class="fad fa-info-circle"></i> Case
                                                    </span>
                                                    <span v-else>
                                                        {{ project.houses_count }} Case
                                                    </span>
                                                </div>
                                                <div class="ep ep3" v-if="project.commercials_models_count > 0">
                                                    <i class="fad fa-object-group"></i>
                                                    <span
                                                        v-if="!project.hasAccessToProjectItems"
                                                        class="item-action-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Pentru informatii despre numarul de spaţii disponibil sunati la numarul de contact din proiect"
                                                    >
                                                        <i class="fad fa-info-circle"></i> Spaţii
                                                    </span>
                                                    <span
                                                        v-else-if="project.commercials_count === 0"
                                                        class="item-action-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                                    >
                                                        <i class="fad fa-info-circle"></i> Spaţii
                                                    </span>
                                                    <span v-else>
                                                        {{ project.commercials_count }} Spaţii
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="element-footer">
                                                <div class="element-size">
                                                    <div class="element-footer-box">
                                                        <i class="fad fa-ruler-triangle"></i>
                                                        <span> Suprafata: </span>
                                                    </div>
                                                    <p v-if="project.min_surface != project.max_surface">
                                                        {{ project.min_surface }} - {{ project.max_surface }} (m²)
                                                    </p>
                                                    <p v-else>{{ project.min_surface }} (m²)</p>
                                                </div>
                                                <div class="element-price">
                                                    <div class="element-footer-box">
                                                        <i class="fad fa-sack-dollar"></i>
                                                        <span> Pret:  </span>
                                                    </div>
                                                    <p>
                                                        <span class="regular-price" v-if="project.min_price != project.max_price">
                                                            {{ formatPrice(project.min_price, false) }} -
                                                            {{ formatPrice(project.max_price) }}
                                                        </span>
                                                        <span class="regular-price" v-else>
                                                            {{ formatPrice(project.min_price) }}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="client-note">
                                            <h5> Notita <span class="edit-element-btn" @click="openEditNotesLocalFavoriteModal(getProjectFavorite(project.id))"> Modifica <i class="fad fa-file-edit"></i> </span> </h5>
                                            <p :id="`notes-${getProjectFavoriteId(project.id)}`">{{ getProjectFavoriteNotes(project.id) }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mgb-15"
                                    v-if="projects.length == 0">
                                    <p>Momentan nu aveti nici un proiect adaugat la favorite</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="section-heading">
                                <i class="fad fa-project-diagram"></i>
                                <h1 class="m-color">
                                    Modele Favorite
                                </h1>
                            </div>
                            <div class="row">
                                <div v-for="(model, key) in models" :key="key"
                                     class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <div class="pp-model-item">
                                        <div class="sold-tag" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                            Vandut
                                        </div>
                                        <div class="saved-item-action" @click="deleteFavoriteModel(model.id)">
                                            <span> Elimina </span>
                                            <i class="fas fa-heart-broken"></i>
                                        </div>
                                        <div class="element-header">
                                            <div class="element-info">
                                                <a :href="`${model.project.url}`" class="general-link element-name">
                                                    {{ model.project.name }}
                                                </a>
                                                <div class="element-location">
                                                    <i class="fad fa-map-marker-alt"></i>
                                                    <p>
                                                        {{ getProjectLocation(model.project) }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="element-dropdown">
                                                <div class="element-floating-menu" @click="setActiveDropdownModel(key)">
                                                    <i class="fad fa-ellipsis-v-alt"></i>
                                                </div>
                                                <ul
                                                    class="actions-dropdown"
                                                    :class="{'actions_dropdown_active': activeIndexModel === key}"
                                                    ref="dropdown"
                                                >
                                                    <li>
                                                        <i class="fad fa-phone-rotary"></i>
                                                        <a href="javascript:void(0)" class="general-link" @click="openPublicContactModalProject(model.project,model)"> Call </a>
                                                    </li>
                                                    <li>
                                                        <i class="fad fa-copy"></i>
                                                        <a href="javascript:void(0)" class="general-link" @click="copyLink(model,'model')"> Copy link </a>
                                                    </li>
                                                    <li>
                                                        <i class="fab fa-whatsapp"></i>
                                                        <a :href="`https://api.whatsapp.com/send?text=${getFullModelUrl(model)}`" class="general-link" target="_blank"> Share Whatsapp </a>
                                                    </li>
                                                    <li>
                                                        <i class="fab fa-facebook-square"></i>
                                                        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${getFullModelUrl(model)}`" class="general-link" target="_blank"> Share Facebook </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="pp-model-item-content pp-length-flex">
                                            <div
                                                class="pp-model-picture pp-length-picture u-cursor-pointer"
                                                :style="{ backgroundImage: 'url(' + model.first_listing_image_url + ')' }"
                                                @click="openModelDetailModal(model.project_id, model.id, 'apartments')">
                                            </div>
                                            <div class="pp-model-info pp-length-info">
                                                <div class="pp-model-info-strip">
                                                    <h2 class="pp-model-item-heading">
                                                        <a href="javascript:void(0)"
                                                           @click="openModelDetailModal(model.project_id, model.id, 'apartments')"> {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{ model.model_type }} </a>
                                                    </h2>
                                                </div>
                                                <div class="pp-model-info-strip">
                                                    <h2> Pret de la:</h2>
                                                    <p v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                        --
                                                    </p>
                                                    <p class="xs-flex-full-width" v-else>
                                                        {{ formatPrice(model.min_price) }} <span class="vat">{{model.price_with_vat ? 'TVA inclus' : '+TVA'}}</span>
                                                    </p>
                                                </div>
                                                <div class="pp-model-info-strip" v-if="model.min_credit_price">
                                                    <h2> Pret cu credit de la:</h2>
                                                    <p v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                        --
                                                    </p>
                                                    <p class="xs-flex-full-width" v-else>
                                                        {{ formatPrice(model.min_credit_price) }} <span class="vat">{{model.credit_price_with_vat ? 'TVA inclus' : '+TVA'}}</span>
                                                    </p>
                                                </div>
                                                <div class="pp-model-info-strip">
                                                    <ul>
                                                        <li class="xs-flex-full-width">
                                                            <span> Supr. totala: </span>
                                                            <span> {{ model.min_surface }} m² </span>
                                                        </li>
                                                        <li class="xs-flex-full-width" v-if="model.terrace_surface">
                                                            <span> Balcon: </span>
                                                            <span> {{ model.terrace_surface }} m² </span>
                                                        </li>
                                                        <li class="xs-flex-full-width" v-if="model.garden_surface && model.type === 'house'">
                                                            <span> Teren: </span>
                                                            <span> {{ model.garden_surface }} m² </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="pp-model-info-strip">
                                                    <p class="pp-avb-item" @click="openModelDetailModal(model.project_id, model.id, 'apartments')">
                                                        <span v-if="model.project && model.project.hasAccessToProjectItems">
                                                            Vezi disponibilitate ({{ model.items_count }})
                                                        </span>
                                                        <span v-else>
                                                            Vezi detalii
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="client-note">
                                            <h5> Notita <span class="edit-element-btn" @click="openEditNotesLocalFavoriteModal(getModelFavorite(model.id))"> Modifica <i class="fad fa-file-edit"></i> </span> </h5>
                                            <p :id="`notes-${getModelFavoriteId(model.id)}`">{{ getModelFavoriteNotes(model.id) }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mgb-15"
                                     v-if="models.length == 0">
                                    <p>Momentan nu aveti nici un model adaugat la favorite</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "GuestFavoritesList",
    props: [],
    data() {
        return {
            activeIndexModel: null,
            activeIndexProject: null,
            showLoading: false,
            favorites: [],
            models: [],
            projects: []
        };
    },
    created: function () {},
    mounted() {
        let vm = this;
        this.favorites = window.getLocalFavorites();
        this.loadFavorites();

        // on open modal
        this.$eventBus.$on(
            "LOCAL_FAVORITE_NOTES_CHANGED",
            async function () {
                vm.favorites = window.getLocalFavorites();
                vm.loadFavorites();
            }
        );

        this.$eventBus.$on('SAVED_FAVORITES', function (payLoad) {
            let fav = payLoad.fav;
            vm.favorites = vm.favorites || [];
            vm.favorites = vm.favorites.concat(fav);
        });

        this.$eventBus.$on('DELETED_FAVORITES_MODAL', function (payLoad) {
            if(vm.favorites.length > 0)
            {
                vm.favorites.forEach((fav, key) => {
                    if(fav.favoritable_id == payLoad.favId && fav.favoritable_type === 'App\\ProjectModel')
                    {
                        vm.favorites.splice(key, 1);
                        return;
                    }
                });
            }
        });
    },

    methods: {
        async loadFavorites() {
            let vm = this
            vm.showLoading = true
            await window.axios.post(`/ajax/get-local-favorites`, {
                localFavorites: vm.favorites
            })
                .then(function (resp) {
                    vm.models = resp.data.data.models;
                    vm.projects = resp.data.data.projects;
                    vm.showLoading = false
                    Vue.nextTick(function () {
                        $('[data-toggle="tooltip"]').tooltip()
                    })
                })
                .catch(function () {
                    vm.showLoading = false
                });
        },
        getProjectFavorite(projectId) {
            return this.favorites.find(favorite => favorite.favoritable_type == 'App\\Project' && favorite.favoritable_id === projectId);
        },
        getProjectFavoriteId(projectId) {
            let localFavorite = this.getProjectFavorite(projectId);
            return localFavorite ? 'project-'+projectId : false;
        },
        getProjectFavoriteNotes(projectId) {
            let localFavorite = this.favorites.find(favorite => favorite.favoritable_type == 'App\\Project' && favorite.favoritable_id === projectId);
            return localFavorite ? localFavorite.notes : false;
        },
        getModelFavorite(modelId) {
            return this.favorites.find(favorite => favorite.favoritable_type == 'App\\ProjectModel' && favorite.favoritable_id === modelId);
        },
        getModelFavoriteId(modelId) {
            let localFavorite = this.getModelFavorite(modelId);
            return localFavorite ? 'model-'+modelId : false;
        },
        getModelFavoriteNotes(modelId) {
            let localFavorite = this.favorites.find(favorite => favorite.favoritable_type == 'App\\ProjectModel' && favorite.favoritable_id === modelId);
            return localFavorite ? localFavorite.notes : false;
        },
        getProjectFavoriteModelCount(projectId) {
            return this.favorites.filter(
                fav => fav.favoritable_type === "App\\ProjectModel" && fav.projectId === projectId
            ).length;
        },
        getProjectLocation(project) {
            let location = [];
            if (project.county) {
                location.push(project.county.name);
            }
            if (project.city) {
                location.push(project.city.name);
            }
            if (project.zone) {
                location.push(project.zone.name);
            }
            if (project.subzone) {
                location.push(project.subzone.name);
            }
            return location.join(', ');
        },
        checkNewFlag(project) {
            let createDate = window.moment(project.created_at);
            let now = window.moment();
            let diff = window.moment.duration(now.diff(createDate));
            return diff.asDays() <= 30;
        },
        setActiveDropdownModel(key) {
            this.activeIndexModel = key;
            const dropdown = this.$refs.dropdown[key]
            if (!dropdown.classList.contains('actions_dropdown_active')) {
                dropdown.classList.add('actions_dropdown_active')
            } else {
                dropdown.classList.remove('actions_dropdown_active')
            }
        },
        setActiveDropdownProject(key) {
            this.activeIndexProject = key;
            const dropdown = this.$refs.dropdown[key]
            if (!dropdown.classList.contains('actions_dropdown_active')) {
                dropdown.classList.add('actions_dropdown_active')
            } else {
                dropdown.classList.remove('actions_dropdown_active')
            }
        },
        deleteFavoriteProject(id) {
            let vm = this;
            window.Swal.fire({
                title: "Esti sigur?",
                text:
                    "Daca stergeti acest proiect vor fi sterse de la favorite si modelele din acest proiect!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Da, sterge!",
                cancelButtonText: "Nu, anuleaza.",
            }).then((result) => {
                if (result.value) {
                    vm.favorites = vm.favorites.filter(
                        fav => !(
                            (
                                fav.favoritable_type === "App\\Project" &&
                                fav.favoritable_id === id
                            ) || (
                                fav.favoritable_type === "App\\ProjectModel" &&
                                fav.projectId === id
                            )
                        )
                    );
                    window.saveLocalFavorites(vm.favorites);

                    window.Swal.fire({
                        position: "top-end",
                        icon: "success",
                        html: "Proiectul a fost sters din lista de favorite.",
                        showConfirmButton: false,
                        timer: 1500,
                    }).then(vm.loadFavorites);
                }
            });
        },
        deleteFavoriteModel(id) {
            let vm = this;

            vm.favorites = vm.favorites.filter(
                fav => !(
                    fav.favoritable_type === "App\\ProjectModel" &&
                    fav.favoritable_id === id
                )
            );
            window.saveLocalFavorites(vm.favorites);

            window.Swal.fire({
                position: 'top-end',
                icon: 'success',
                html: 'Modelul a fost sters din lista de favorite.',
                showConfirmButton: false,
                timer: 1500
            }).then(vm.loadFavorites);
        }
    },
};
</script>